/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {useNavigate} from "react-router-dom"
function Page404() {
  const navigate = useNavigate()
  return (
    <section className="flat-error center " style={{ minHeight : "100vh" }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="images">
              <img
                src="/assets/images/mark/mark-error.png"
                alt="images"
                width={500}
              />
            </div>
            <div className="heading-sections center">
              <h2>Oups.. Votre page est perdue.</h2>
              <p className="text-color-2">
                Nous avons cherché partout mais nous n’avons pas trouvé ce que
                vous cherchiez. Trouvons un meilleur endroit où aller.
              </p>
              <div className="button-error center">
                <a
                  className="sc-button"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <span>Revenir en lieu sûr</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Page404